export const home = {
overview_label: 'CORPORATE OVERVIEW',
overview_title: 'Built for Responsible Growth.',
overview_text: 'One More Global Inc. develops and distributes wellness and personal care products through a direct sales model supported by independent distributors. The company focuses on product quality, disciplined operations, market development, and consistent customer service.',

// Homepage Product Cards
products_label: 'PRODUCT & TECHNOLOGY',
products_title: 'Practical Products for Everyday Wellness',
products_subtitle: 'Designed for convenient daily use with attention to quality and ease of application.',

tts_title: 'Skin-Applied Patch Products',
tts_desc: 'A portfolio of practical patch-format products designed for convenient everyday wellness and personal care routines.',

glutanad_title: 'One More GlutaNAD+ BOOST',
glutanad_desc: 'A premium oral-strip formulation featuring NMN, glutathione, and selected nutritional ingredients for convenient daily use.',

// Homepage Overview Cards
overview_card_1_title: 'Product Portfolio',
overview_card_1_desc: 'Wellness and personal care products developed for convenient everyday use.',
overview_card_2_title: 'Direct Sales',
overview_card_2_desc: 'A product-focused direct sales model supported by independent distributors.',
overview_card_3_title: 'Market Development',
overview_card_3_desc: 'Structured market development based on long-term business relationships and responsible execution.',
overview_card_4_title: 'Corporate Operations',
overview_card_4_desc: 'Clear internal processes supporting distribution, partnerships, communication, and organizational growth.',

exec_label: 'EXECUTIVE LEADERSHIP',
exec_title: 'International Direction & Strategic Oversight',
exec_name: 'Alper Volkan Karpuz',
exec_role: 'Chief Executive Officer (CEO)',
exec_bio: 'Directing international operations with extensive experience in global expansion strategy, cross-border organizational development, and multi-market business scaling. Responsible for aligning regional execution with global corporate objectives.',
exec_bio_extended: 'Under his strategic direction, One More Global Inc. has established a structured operational framework across the Americas, coordinating distribution networks, regulatory compliance, and market entry strategies with precision and corporate discipline.',
strength_label: 'Corporate Strength',
strength_title: 'Why Our Structure Drives Results',
strength_subtitle: 'A structured global model designed for scalability, operational control, and sustained international growth.',
strength_1_title: 'Structured Expansion Model',
strength_1_desc: 'Our operations model enables systematic market entry with dedicated operational support, reducing risk and accelerating growth in new territories.',
strength_2_title: 'Operational Control & Efficiency',
strength_2_desc: 'Centralized strategy with decentralized execution ensures rapid response to local market dynamics while maintaining global standards and quality benchmarks.',
strength_3_title: 'Scalable International Framework',
strength_3_desc: 'The company is designed to scale — operating as a self-sufficient unit while maintaining high standards, brand equity, and strategic coordination.',
strength_4_title: 'Leadership-Driven Governance',
strength_4_desc: 'Executive oversight at every level ensures accountability, strategic alignment, and consistent execution of the company\'s international growth mandate.',
capabilities_label: 'Operational Capabilities',
capabilities_title: 'International Business Approach',
cap_1_title: 'Market Entry & Expansion',
cap_1_desc: 'Systematic approach to entering new markets with regulatory preparation, partnership development, and distribution infrastructure.',
cap_2_title: 'Distribution Network Management',
cap_2_desc: 'End-to-end coordination of multi-channel distribution systems across diverse geographic and regulatory environments.',
cap_3_title: 'Cross-Border Operations',
cap_3_desc: 'Managing operational complexity across multiple jurisdictions with local compliance and international standards alignment.',
cap_4_title: 'Strategic Partnership Development',
cap_4_desc: 'Building and maintaining institutional relationships that support market access, regulatory navigation, and sustainable growth.',
cap_5_title: 'Regulatory & Compliance Coordination',
cap_5_desc: 'Proactive regulatory engagement ensuring full compliance across all operating markets within the Americas.',
cap_6_title: 'Organizational Scaling',
cap_6_desc: 'Building internal structures and processes that support rapid but controlled expansion into new territories and market segments.',
operations_label: 'Global Operations',
operations_title: 'Strategic Presence Across the Americas',
operations_subtitle: 'Coordinating distribution networks and market expansion from our Houston headquarters.',
compliance_label: 'Corporate Governance',
compliance_title: 'Standards, Governance & Accountability',
compliance_subtitle: 'Maintaining the highest standards of corporate governance, quality assurance, and regulatory compliance across every market we serve.',
contact_label: 'Corporate Inquiries',
contact_title: 'Connect With Our Corporate Office',
contact_subtitle: 'For business development, distribution partnerships, institutional inquiries, and corporate communications.',
contact_cta: 'Submit an Inquiry',
};
